<template>
    <div>
        <section class="bg-primary" style="border-top: solid 1px #B6C6BC">
            <div class="container">
                <div class=" text-block-padding">

                    <div class="row">
                        <div class="col-lg-8 mx-auto">
                            <h1 class="text-white">Quiz</h1>
                            <h2 class="mb-4 text-white-50">Voici 15 affirmations, qu’en pensez-vous ?</h2>
                            <b-card v-for="question in questions"
                                    :title="question.text"
                                    :key="'question'+question.nth"
                                    class="shadow mb-3">
                                <b-form-radio-group
                                    v-model="question.value"
                                    :options="options"
                                    class="mb-0"
                                    value-field="item" text-field="name"
                                    stacked
                                    disabled-field="notEnabled"/>
                            </b-card>
                            <b-alert variant="danger" :show="disableSubmit">
                                Vous devez répondre à toutes les questions pour afficher le résultat
                            </b-alert>
                            <b-button variant="light" :disabled="disableSubmit" @click="showResult">
                                Afficher le résultat
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "questionnaire",

    data() {
        return {
            questions: [
                {nth: 1, text: "Nous dépensons beaucoup d’argent en aides sociales", value: null},
                {nth: 2, text: "Nos entreprises ne sont pas assez compétitives", value: null},
                {nth: 3, text: "Notre administration est pléthorique", value: null},
                {nth: 4, text: "Notre pays voit la précarité augmenter", value: null},
                {nth: 5, text: "Les Français ont peur de l’avenir", value: null},
                {nth: 6, text: "Avec la pandémie, la pauvreté a augmenté", value: null},
                {nth: 7, text: "Nous avons trop d’impôts et de taxes", value: null},
                {nth: 8, text: "Les charges sociales en entreprise sont trop élevées", value: null},
                {nth: 9, text: "Nous importons trop de produits que nous pourrions fabriquer en France", value: null},
                {
                    nth: 10,
                    text: "Les étudiants boursiers doivent travailler en plus de leurs études pour  vivre normalement",
                    value: null
                },
                {nth: 11, text: "Notre système de retraite est trop compliqué", value: null},
                {nth: 12, text: "Notre pays manque de justice sociale", value: null},
                {nth: 13, text: "Nos aides sociales incitent les étrangers à venir en France", value: null},
                {nth: 14, text: "Le chômage est une plaie que nous ne savons pas résoudre", value: null},
                {
                    nth: 15,
                    text: "Nos gouvernants n’ont pas encore saisi l’importance du mal-être Français",
                    value: null
                },
            ],
            options: [
                {item: 'PAD', name: "Pas d'accord"},
                {item: 'NSP', name: "Ne sais pas"},
                {item: 'DAC', name: "D'accord"},
            ]
        }
    },

    created() {
        this.resetStore()
    },

    methods: {
        resetStore() {
            this.$store.replaceState({
                quiz: {
                    padCount: 0,
                    nspCount: 0,
                    dacCount: 0
                }
            })
        },

        showResult() {
            this.scrollTop()
            this.$store.commit('quiz/SET_PAD_COUNT', this.padQuestionsCount)
            this.$store.commit('quiz/SET_NSP_COUNT', this.nspQuestionsCount)
            this.$store.commit('quiz/SET_DAC_COUNT', this.dacQuestionsCount)
            this.$router.push({name: 'result'})
        },

        scrollTop() {
            window.scrollTo(0, 0);
        }
    },

    computed: {
        root() {
            return document.head.querySelector('meta[name="root-url"]').content
        },

        padQuestionsCount() {
            return this.questions.filter(item => item.value === 'PAD').length
        },

        nspQuestionsCount() {
            return this.questions.filter(item => item.value === 'NSP').length
        },

        dacQuestionsCount() {
            return this.questions.filter(item => item.value === 'DAC').length
        },

        disableSubmit() {
            return this.padQuestionsCount + this.nspQuestionsCount + this.dacQuestionsCount !== 15
        }
    }
}
</script>

<style scoped>

</style>
